// extracted by mini-css-extract-plugin
export default {"successStoriesBanner":"KoWKRCXnzJ2PC8ZVDY2Q","successStories":"sy5VhOr5w9Yxgu6dWILf","highlight":"y0Qzdm72Wflcy292lpwM","fromHuge":"CP3ZrcSCM_MGxt6zCcxS"};